const removeClass = (element, classNames) => {
  if (!element) {
    throw new Error("Element is required");
  }
  const classes = Array.isArray(classNames) ? classNames.filter(Boolean) : classNames.split(" ").filter(Boolean);
  element.classList.remove(...classes);
};
export {
  removeClass
};
//# sourceMappingURL=removeClass.js.map
